import React from 'react';
import { createPortal } from 'react-dom';
import useStaticPopperActionPopup from '../../../hooks/useStaticPopperActionPopup';
import classes from './ActionsPopup.module.css';

const ActionsPopup = ({ children, btnOpenContent}) => {

  const { showMenu, menuStyles, buttonRef, menuRef, toggleMenu, closeMenu } = useStaticPopperActionPopup();

  const handleToggle = (e) => {
    e.stopPropagation();
    toggleMenu();
  };

  return (
    <div className={classes.ActionsPopup}>
      <div className={classes.BtnOpen} ref={buttonRef} onClick={handleToggle}>
        {btnOpenContent || '⋮'}
      </div>

      {showMenu && createPortal(
        <div className={classes.ActionsWrapper} ref={menuRef} style={menuStyles}>
          {React.Children.map(children, (child) =>
            child && React.cloneElement(child, { closeMenu })
          )}
        </div>
        , document.body)}
    </div>
  );
};

export default ActionsPopup;
